import { TransferConfig } from '../config/transfer-config';

import Logger from '@module/logger';

export class MultipartChunk {
  constructor(transferId, file, partNumber) {
    this.transferId = transferId;
    this.file = file;
    this.fileId = file.id;
    this.partNumber = partNumber;

    this.blob = null;
    this.attempts = 0;

    this.uploadCancelToken = null;
  }

  set cancelToken(cancelToken) {
    this.uploadCancelToken = cancelToken;
  }

  get cancelToken() {
    return this.uploadCancelToken;
  }

  get content() {
    if (this.blob) return this.blob;

    const sliceMethod =
      this.file.ref.slice ||
      this.file.ref.mozSlice ||
      this.file.ref.webkitSlice;

    const chunkStart = this.partNumber * this.file.multipart.chunkSize;
    const chunkEnd = (this.partNumber + 1) * this.file.multipart.chunkSize;
    this.blob = sliceMethod.call(this.file.ref, chunkStart, chunkEnd);

    return this.blob;
  }

  canRetry() {
    this.attempts++;

    if (this.file.didFileSizeChange()) return false;
    if (this.attempts > TransferConfig.queue.retryLimit) return false;

    return true;
  }

  uploadComplete() {
    Logger.log(
      `[${this.file.name}] Upload for part #${this.partNumber} completed`
    );

    // Notify the file that the chunk has been uploaded.
    this.file.chunkUploaded(this);
    this.blob = null;
  }

  abort() {
    Logger.log(`[${this.file.name}] Aborting part #${this.partNumber}`);

    this.attempts = 0;
    this.file.chunkAborted(this);

    if (this.uploadCancelToken) {
      this.uploadCancelToken.cancel();
    }
  }
}
